export default "__VITE_ASSET__BqNx6uu5__"